/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useRef, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import {getUserByToken, login} from '../core/_requests'
import {useAuth} from '../core/Auth'
import {toAbsoluteUrl} from 'src/marketConnect/helpers'
import {fetchUserAccountDetailsAsync} from 'src/redux/actions/accountActions'
import {fetchPlatformsAsync} from 'src/redux/actions/platformActions'
import {useAppDispatch, useAppSelector, withSkipGlobalApiError} from 'src/redux/storeHooks'
import {handleOauthForConnectPlatformAsync, loginAsync,validateUserSessionGetAsync} from 'src/redux/actions/authActions'
import {accessSessionTokenKeyName, refreshSessionTokenKeyName} from 'src/utils/constants'
import {finalizeTikTokAfterAuth} from 'src/utils/finalizeTikTokAfterAuth'
import {resetImpersonationForFreshLogin} from 'src/utils/impersonationTokens'
import {
  captureWalmartMarketplaceHandoffFromSearch,
  getWalmartPlatformIdFromPayload,
  getUserIdFromAuthPayload,
  redirectToWalmartMarketplaceAuthIfNeeded,
} from 'src/utils/walmartMarketplaceHandoff'
import useAppToast from 'src/hooks/useAppToast'
import {messageTemplete} from 'src/utils/messageTemplete'
import {userInfo} from 'os'
import { TwakScript } from 'src/externalScript/TwakScript'
import {Modal, Button, Form  } from 'react-bootstrap'
import GoogleLoginButton from './GoogleLoginButton'
import ReCAPTCHA from 'react-google-recaptcha'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(8, 'Minimum 8 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const [captchaToken, setCaptchaToken] = useState<string | null>(null)
  const captchaRef = useRef<ReCAPTCHA | null>(null)
  const captchaTokenRef = useRef<string | null>(null)
  const {saveAuth, setCurrentUser} = useAuth()
  const dispatch = useAppDispatch()
  const {} = useAppSelector((state) => state.auth)
  const {successToast, errorToast, warningToast} = useAppToast()
    const [pendingLogin, setPendingLogin] = useState(initialValues)
    const navigate = useNavigate();
    const {search} = useLocation()
  const resetCaptcha = () => {
    captchaRef.current?.reset()
    captchaTokenRef.current = null
    setCaptchaToken(null)
  }

  useEffect(() => {
    const handoffStatus = captureWalmartMarketplaceHandoffFromSearch(search)
    if (handoffStatus === 'invalid') {
      errorToast('Walmart authorization URL is missing or invalid.')
    }
  }, [errorToast, search])


  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      const currentCaptchaToken = captchaTokenRef.current
      if (!currentCaptchaToken) {
        errorToast('Please complete captcha verification.')
        return
      }
      setLoading(true)
      try {
        await dispatch(
          loginAsync(withSkipGlobalApiError({
            email: values.email,
            password: values.password,
            'g-recaptcha-response': currentCaptchaToken,
          }))
        )
           .then(async (response) => {
            // console.log('response status:',)



 if (response.payload?.status=='400'
  && response.payload?.data?.session_token && response.payload?.data?.otp_required == "True"
)
   {
      // ✅ MFA required
      const msg = response.payload?.data?.message
      const token = response.payload?.data?.session_token
dispatch(validateUserSessionGetAsync(withSkipGlobalApiError({session_token:token})))
.then((response)=> {
  if(response.payload?.data?.is_valid){ navigate('/auth/mfa-login',{state:{...values,sessionToken:token}});
  errorToast(msg)
  setLoading(false);
  setPendingLogin(values)

}else{
  errorToast(response.payload?.data?.massage)
  resetCaptcha()
}})
      return
    }
 if (response.payload?.status=="400"
  && response.payload?.data?.session_token && response.payload?.data?.otp_required === "False"
)
   {
      const token = response.payload?.data?.session_token
      const email = response.payload?.data?.email
         const msg = response.payload?.data?.message
dispatch(validateUserSessionGetAsync(withSkipGlobalApiError({session_token:token})))
.then((response)=> {
  if(response.payload?.data?.is_valid){ navigate('/auth/mfa-password',{state:{email:email,sessionToken:token}});
    errorToast(msg)
  setLoading(false);
  setPendingLogin(values)

}else{
  errorToast(response.payload?.data?.massage)
  resetCaptcha()
}})
      return
    }




            if(response.payload?.status=='401'){
              warningToast(response?.payload?.data?.detail)
              resetCaptcha()
            }

            // localStorage.setItem('userid', email)
            // console.log("userid:",localStorage.getItem(`userid`))
            // if(response.meta.requestStatus=='fulfilled'){

            //   console.log("login data", response.payload);
            //     // sessionStorage.setItem(sessionTokenKeyName, "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c")
            //     // setSubmitting(false)
            //     setLoading(false)
            //   }else{
            //     errorToast("login failed")
            //     setSubmitting(false)
            //     setLoading(false)
            //   }
//  if (response?.payload?.status === 400){
//  errorToast(response.payload?.data.message)
//  }
            if (response?.payload?.status === 401) {
              errorToast(response?.payload?.detail)
              setLoading(false)
              resetCaptcha()
            } else if (response?.payload?.access) {
              resetImpersonationForFreshLogin()
              // console.log('show toast msg')
              localStorage.setItem(accessSessionTokenKeyName, response?.payload?.access)
              localStorage.setItem(refreshSessionTokenKeyName, response?.payload?.refresh)
              let walmartOauthUserId = getUserIdFromAuthPayload(response?.payload)
              if (!walmartOauthUserId) {
                const userResponse = await dispatch(fetchUserAccountDetailsAsync())
                walmartOauthUserId = getUserIdFromAuthPayload(userResponse?.payload)
              }
              const walmartPlatformResponse = await dispatch(fetchPlatformsAsync({search: 'WALMART'}))
              const walmartPlatformId = getWalmartPlatformIdFromPayload(walmartPlatformResponse?.payload)
              if (await redirectToWalmartMarketplaceAuthIfNeeded((params) =>
                dispatch(handleOauthForConnectPlatformAsync(params)),
                {user_id: walmartOauthUserId, platform_id: walmartPlatformId}
              )) {
                return
              }
              await finalizeTikTokAfterAuth(dispatch)
              successToast(messageTemplete.LOGIN_SUCCESS)
              setLoading(false)
            } else {
              // errorToast(messageTemplete.SOMETHING_WENT_WRONG)
              errorToast(response.payload?.data.message)
              setLoading(false)
              resetCaptcha()
            }
          })
          .catch((error) => {
            console.log('error catch:', error)
            setLoading(false)
            resetCaptcha()
          })
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
        resetCaptcha()
      }
    },
  })

  // useEffect(() => {
  //   // Check if the script is already added
  //   const scriptId = "mouseflow-script";
  //   if(process.env['REACT_APP_ENV'] === 'production'){
  //     if (!document.getElementById(scriptId)) {
  //       const script = document.createElement("script");
  //       script.type = "text/javascript";
  //       script.defer = true;
  //       script.src = "//cdn.mouseflow.com/projects/d9c4c389-87cf-4a12-a4f1-2358807273b2.js";
  //       script.id = scriptId;
  //       document.head.appendChild(script);
  
  //       // Initialize the Mouseflow queue if not already set
  //       (window as any)._mfq = (window as any)._mfq || [];
  //     }
  //   }
  //   // Cleanup function to remove the script when the component unmounts
  //   return () => {
  //     const existingScript = document.getElementById(scriptId);
  //     if (existingScript) {
  //       existingScript.remove();
  //     }
  //     // Optionally clear the Mouseflow queue
  //     (window as any)._mfq = undefined;
  //   };
  // }, []); // Empty dependency array ensures it runs only once when the component mounts

  return (
    <>
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Sign In</h1>
      </div> 
      
      <div className="text-center mb-3">
        {/* <Button
          variant="outline-primary"
          className="google-button d-flex align-items-center justify-content-center gap-2 w-100"
          style={{ border: "1px solid #0d6efd" }}
        >
          <img
            src="https://cdn1.iconfinder.com/data/icons/google-s-logo/150/Google_Icons-09-512.png"
            alt="Google logo"
            width="20"
            height="20"
            className="google-icon"
          />
          Sign In with Google
        </Button> */}
        <GoogleLoginButton />
        <div className="d-flex align-items-center mt-4 mb-2">
          <div className="flex-grow-1 border-bottom"></div>
          <span className="mx-2 text-muted fw-bold">Or</span>
          <div className="flex-grow-1 border-bottom"></div>
        </div>
      </div>
      {/* begin::Heading */}
      
      {/* begin::Heading */}

      {/* begin::Login options */}
      {/* <div className='row g-3 mb-9'> */}
      {/* begin::Col */}
      {/* <div className='col-md-6'> */}
      {/* begin::Google link */}
      {/* <a
            href='#'
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
              className='h-15px me-3'
            />
            Sign in with Google
          </a> */}
      {/* end::Google link */}
      {/* </div> */}
      {/* end::Col */}

      {/* begin::Col */}
      {/* <div className='col-md-6'> */}
      {/* begin::Google link */}
      {/* <a
            href='#'
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black.svg')}
              className='theme-light-show h-15px me-3'
            />
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black-dark.svg')}
              className='theme-dark-show h-15px me-3'
            />
            Sign in with Apple
          </a> */}
      {/* end::Google link */}
      {/* </div> */}
      {/* end::Col */}
      {/* </div> */}
      {/* end::Login options */}

      {/* begin::Separator */}
      {/* <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>
      </div> */}
      {/* end::Separator */}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
        <input
          placeholder='Email'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
            <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-3'>
        <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
        <input
          placeholder='Password'
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Wrapper */}
      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <div />

        {/* begin::Link */}
        <Link to='/auth/forgot-password' className='link-primary'>
          Forgot Password ?
        </Link>
        {/* end::Link */}
      </div>
      {/* end::Wrapper */}

      <div className='captcha-box my-2 overflow-hidden'>
        <ReCAPTCHA
          ref={captchaRef}
          sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY!}
          onChange={(val) => {
            captchaTokenRef.current = val
            setCaptchaToken(val)
          }}
        />
      </div>

      {/* begin::Action */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid || !captchaToken}
        >
          {!loading && <span className='indicator-label'>Continue</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}

      <div className='text-gray-500 text-center fw-semibold fs-6'>
        Not a Member yet?{' '}
        <Link to={`/auth/registration${search || ''}`} className='link-primary'>
          Sign up
        </Link>
      </div>
    </form>
    <TwakScript/>
    </>
  )
}
